import StdAnimations from "../StdAnimations.js";

export default function FooterModule(element) {
    let qs = element.querySelector.bind(element);
    let qsa = element.querySelectorAll.bind(element);

    let $container = qs('.container');
    let $logo = qs('.footer__logo img');

    let tl = gsap.timeline({});

    qsa('.slide-me').forEach(function(subelem) {
        tl.from(subelem, StdAnimations.appearSlide, '<0.2');
    });
    
    tl.from(qs('.footer__detail--top'), StdAnimations.appearPop, '<0.2');
    tl.from(qs('.footer__detail--bottom'), StdAnimations.appearPop, '<0.2');
    
    tl.pause();

    gsap.from($container, { 
        y: -300, 
        scrollTrigger: { 
            trigger: $container, 
            start: 'top 80%', 
            end: '+=300', 
            scrub: 1,
            onUpdate: function(self) {
                if (self.progress > 0.9) {
                    tl.play();
                }
            }
        },
        onComplete: function (params) {
            
        }
    });
}
